import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { styled } from '@mui/material/styles';
import {
  Fade,
  Paper,
} from '@mui/material';

type Props = {
  children: React.ReactNode;
  open: boolean;
  anchorEl: HTMLElement | null;
  id: string;
};

const AbsContainer = styled(Paper)(({
  open,
  anchorel,
}: { open: boolean, anchorel: HTMLElement }) => ({
  display: open ? 'block' : 'none',
  position: 'absolute',
  top: anchorel.getBoundingClientRect().top + window.scrollY,
  left: anchorel.clientLeft + anchorel.clientWidth + 10,
  zIndex: 1000,
  padding: 12,
}));

const MenuAbsolute: React.FC<Props> = ({
  id,
  children,
  open,
  anchorEl,
}: Props) => {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [open]);

  if (!anchorEl) {
    return null;
  }

  return (
    <>
      {
        createPortal(
          <Fade in={open} timeout={300}>
            <AbsContainer id={id} open={open} anchorel={anchorEl}>
              {children}
            </AbsContainer>
          </Fade>,
          document.body,
        )
      }
    </>
  );
};

export default MenuAbsolute;
